import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { RepairServices } from './pages/RepairServices';
import { Contact } from './pages/Contact';
import { FAQ } from './pages/FAQ';
import { Cancellation } from './pages/Cancellation';
import { Refund } from './pages/Refund';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
export function AppRouter() {
  return <BrowserRouter data-id="element-1">
      <Routes data-id="element-2">
        <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
        <Route path="/about" element={<About data-id="element-6" />} data-id="element-5" />
        <Route path="/repair-services" element={<RepairServices data-id="element-8" />} data-id="element-7" />
        <Route path="/contact" element={<Contact data-id="element-10" />} data-id="element-9" />
        <Route path="/faq" element={<FAQ data-id="element-12" />} data-id="element-11" />
        <Route path="/cancellation" element={<Cancellation data-id="element-14" />} data-id="element-13" />
        <Route path="/refund" element={<Refund data-id="element-16" />} data-id="element-15" />
        <Route path="/privacy-policy" element={<Privacy data-id="element-18" />} data-id="element-17" />
        <Route path="/terms-of-service" element={<Terms data-id="element-20" />} data-id="element-19" />
      </Routes>
    </BrowserRouter>;
}